import React, { useState, useEffect, useMemo } from 'react';
import { ImClipboard } from "react-icons/im";
import { VscServerProcess } from "react-icons/vsc";
import { TbPackageExport } from "react-icons/tb";
import { FaJira } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Link } from 'react-router-dom';

import './../styles/statusBar.css';
import { parseDate } from '../utils/parseDate';
import TrackItComponent from './TrackItComponent';
import CreateJiraComponent from './JiraTabComponent';
import EmailingComponent from './EmailingTabComponent';
import ModalContentDetails from './ModalContentComponent';
import { getStepFromStatus, getStatusText, getCssClassName, getIconColor, getFlowLinkType } from '../utils/Miscellaneous';

const TrackItStatus = ({ transactions = {} }) => {
    const transactionArray = useMemo(() => {
        return Array.isArray(transactions) ? transactions : [transactions];
    }, [transactions]);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentTransaction, setCurrentTransaction] = useState(null);
    const [trackItActive, setTrackItActive] = useState(false);
    const [trackItParams, setTrackItParams] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    const [visibleTabs, setVisibleTabs] = useState({
        logs: false,
        jira: false,
        email: false,
    });
    const [flowLinkType, setFlowLinkType] = useState();
    const [inboundStatusFlag, setInboundFlowStatusFlag] = useState(false);
    const [outboundStatusFlag, setOutboundFlowStatusFlag] = useState(false);

    useEffect(() => {
        if (transactionArray.length > 0) {
            const outboundStatusFlag = transactionArray.some(transaction =>
                transaction.messageFlowType === 'OUTBOUND' &&
                getStatusText(transaction.boomiStatus) === 'received' &&
                transaction.inboundFlowInd === 'Y'
            );

            const inboundStatusFlag = transactionArray.some(transaction =>
                transaction.messageFlowType === 'INBOUND' &&
                getStatusText(transaction.boomiStatus) === 'sent' &&
                transaction.outboundFlowInd === 'Y'
            );

            setOutboundFlowStatusFlag(outboundStatusFlag);
            setInboundFlowStatusFlag(inboundStatusFlag);

            const transactionWithFlowType = transactionArray.find(transaction => transaction.messageFlowType);
            const linkType = transactionWithFlowType ? getFlowLinkType(transactionWithFlowType) : 'Unknown';

            setFlowLinkType(linkType);
        }
    }, [transactionArray]);

    const getFlowLinkType = (transaction) => {
        if (transaction.messageFlowType === 'OUTBOUND') {
            return 'Inbound';
        } else if (transaction.messageFlowType === 'INBOUND') {
            return 'Outbound';
        } else {
            return 'Unknown';
        }
    };

    const openModal = (transaction) => {
        if (transaction) {  // Ensure the transaction exists before opening the modal
            setCurrentTransaction(transaction);
            setModalIsOpen(true);
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setCurrentTransaction(null);
    };

    const handleTabClick = (tab) => {
        setVisibleTabs(prevState => ({
            ...prevState,
            [tab]: !prevState[tab],
        }));
        setActiveTab(tab);
    };

    const handleTrackItClick = () => {

        console.log("flowLinkType", flowLinkType)

        //setCurrentTransaction(null);
        setTrackItActive(false);
        setTrackItParams(null);
        setVisibleTabs({
            logs: false,
            jira: false,
            email: false,
        });

        if (transactionArray.length === 0) return;

        const customerName = flowLinkType === "Inbound" ? transactionArray[0]?.receiverName : transactionArray[0]?.senderName;
        console.log("flowLinkType", flowLinkType)


        const referenceIdentifier = transactionArray[0]?.documentIdentifier;

        setTrackItParams({ customerName, flowLinkType, referenceIdentifier });
        setTrackItActive(true);
    };

    const steps = ['Received', 'Processing', 'Sent'];
    const icons = [ImClipboard, VscServerProcess, TbPackageExport];
    const isDisabled = transactionArray.length === 0 ||
        transactionArray[transactionArray.length - 1].boomiStatus === 'Complete' ||
        transactionArray.some(transaction => transaction.boomiStatus === 'Incomplete');

    return (
        <div className='transaction-group-container'>
            <div className='status-bar-container'>
                {!trackItActive && transactionArray.length > 0 && (
                    <>
                        <Link to={`/transaction/${transactionArray[0]?.messageGroupId}/status`} className='transaction-link'>
                            <p className='transaction-status-header'>Transactions Status</p>
                        </Link>
                    </>
                )}

                {!trackItActive && transactionArray.length > 0 && (
                    <>
                        <div className='status-bar-top'>
                            <p>
                                {transactionArray[0].documentType}: {transactionArray[0].documentIdentifier}
                                <div>ReferenceType: {transactionArray[0].documentReferenceType}</div>
                            </p>
                            <p>Sender: {transactionArray[0].senderName}
                                <p>Order Number: {transactionArray[0].inboundReference}</p>
                                <p>Received Date: {parseDate(transactionArray[0].DateTime)}</p>
                                <p>Receiver: {transactionArray[0].receiverName}</p>
                            </p>
                        </div>

                        <div className='status-bar'>
                            {steps.map((step, stepIndex) => {
                                const stepTransaction = transactionArray.find(transaction => getStepFromStatus(transaction.boomiStatus) === step);
                                const isStepAvailable = stepTransaction != null;  // Check if step data is available

                                return (
                                    <div key={stepIndex} className={`step-container ${isStepAvailable ? getIconColor(step, transactionArray) : ''}`}>
                                        <div className={`status-step ${isStepAvailable ? getCssClassName(step, transactionArray) : 'no-data'}`}>
                                            <div className='icon'>
                                                <button
                                                    onClick={() => openModal(stepTransaction)}
                                                    disabled={!isStepAvailable || isDisabled}
                                                >
                                                    {React.createElement(icons[stepIndex], { size: 28 })}
                                                </button>
                                            </div>
                                            <p>{step}</p>
                                            {!isStepAvailable && <p className="no-data-text">No data</p>} {/* Show fallback if no data */}
                                        </div>
                                        {stepIndex < steps.length - 1 && (
                                            <div className={`step-line ${isStepAvailable ? getCssClassName(step, transactionArray) : 'no-data-line'}`}>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {modalIsOpen && currentTransaction && (
                            <ModalContentDetails
                                transaction={currentTransaction}
                                closeModal={closeModal}
                            />
                        )}
                    </>
                )}
            </div>
            <div>
                {!trackItActive && (
                    <div className='tabs'>
                        <button onClick={() => handleTabClick('logs')} title='Logs'>
                            <ImClipboard size={20} />
                        </button>
                        <button onClick={() => handleTabClick('jira')} title='Jira'>
                            <FaJira size={20} />
                        </button>
                        <button onClick={() => handleTabClick('email')} title='Email'>
                            <MdEmail size={20} />
                        </button>
                        {(inboundStatusFlag || outboundStatusFlag) && (
                            <button onClick={handleTrackItClick}>
                                Track {flowLinkType}
                            </button>
                        )}
                    </div>
                )}
                {trackItActive && trackItParams && (
                    <TrackItComponent
                        customerName={trackItParams.customerName}
                        flowLinkType={trackItParams.flowLinkType}
                        referenceIdentifier={trackItParams.referenceIdentifier}
                    />
                )}
                {visibleTabs.logs &&
                    <div className='transaction-logs'>
                        {transactionArray
                            .sort((a, b) => parseDate(b.DateTime) - parseDate(a.DateTime))
                            .map((transaction, index) => (
                                <div key={index} className='transaction-log-item'>
                                    {parseDate(transaction.DateTime)?.toLocaleString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        fractionalSecondDigits: 3
                                    }) || 'Invalid Date'} - Boomi &nbsp;
                                    {getStepFromStatus(transaction.boomiStatus)}&nbsp;
                                    EDI &nbsp;
                                    {transaction.documentType} {transaction.documentReferenceType} {transaction.documentIdentifier}&nbsp;
                                    {getStatusText(transaction.boomiStatus) === 'sent'
                                        ? `to ${transaction.receiverName}`
                                        : `from ${transaction.senderName}`} &nbsp;
                                    {
                                        (/Received-Error|Translated-Error|Sent-Error|Sent-C2C-Error|Sent-TMF-Error|Sent-Footprint-Error|Sent-TP-Error|Sent-Softeon-Error/.test(transaction.boomiStatus))
                                            ?
                                            'with errors' : ''}
                                </div>
                            ))}

                    </div>}
                {visibleTabs.jira && <CreateJiraComponent />}
                {visibleTabs.email && <EmailingComponent />}
            </div>
        </div>
    );
};

export default TrackItStatus;
